export default __webpack_public_path__ + "static/media/settings-icon.d6fb3b04.svg";